<div class="card w-100 shadow" [ngClass]="{'scss-card-margin': !disablePadding}" #card>
    <div [attr.data-sb-qa]="qaTag" [ngClass]="{'padding-16': isMobileOrTablet && !disablePadding, 'padding-24': !isMobileOrTablet && !disablePadding}">
        @if (isLoading) { <!-- Review: Right now this is a default sckelecton, we probably want to add a projectable loading state, or make this better -->
            <ng-container>
                <div class="form-field-loading-small"></div>
            </ng-container>
        } @else {
            <ng-container>
                <h4 #header [hidden]="!header.textContent" [ngClass]="{'pb-4': header.hasChildNodes()}">
                    <ng-content select="[header]"></ng-content>
                </h4>
                <ng-content></ng-content>
            </ng-container>
        }
    </div>
</div>
